/**
 * Instrument display texts. English falls back to the texts
 * defined in the domain/catalog, so only German needs to be listed here.
 */
export const catalog = {
  en: {} as Record<string, string>,
  de: {
    "inst.crypto:btc-usd": "Bitcoin",
    "inst.crypto:eth-usd": "Ethereum",
    "inst.etf:spy": "S&P-500-ETF",
    "inst.etf:qqq": "Nasdaq-100-ETF",
    "inst.stock:aapl": "Apple",
    "inst.stock:msft": "Microsoft",
    "inst.stock:nvda": "NVIDIA",
    "inst.fx:eur-usd": "Euro / US-Dollar",
    "inst.fx:gbp-usd": "Britisches Pfund / US-Dollar",
    "inst.fx:usd-jpy": "US-Dollar / Japanischer Yen",
    "inst.metal:gold": "Gold (Spot)",
    "inst.metal:silver": "Silber",
    "inst.commodity:wti": "Rohöl (WTI)",
    "inst.index:dax": "DAX 40",
    "inst.index:dxy": "US-Dollar-Index",
    "inst.index:spx": "S&P 500",
    "inst.index:ndx": "Nasdaq 100",
  } as Record<string, string>,
};
